<script setup lang="ts">
withDefaults(
  defineProps<{
    elevation?: 'raised' | 'high'
  }>(),
  {
    elevation: 'raised',
  },
)
</script>

<template>
  <section
    data-component="VCard"
    class="rounded-lg bg-white px-[var(--card-padding-x,1.5rem)] py-[var(--card-padding-y,1.25rem)]"
    :class="`elevation-${elevation}`"
  >
    <slot />
  </section>
</template>
